module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-select', {
    attrs: {
      "placeholder": "Select Location Tag",
      "options": _vm.allTags,
      "label": "name",
      "name": "locationtag"
    },
    model: {
      value: (_vm.locationtag),
      callback: function($$v) {
        _vm.locationtag = $$v
      },
      expression: "locationtag"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-text', {
    ref: "speaktext",
    attrs: {
      "label": "Speak Text",
      "name": "speaktext",
      "validation": "required"
    },
    model: {
      value: (_vm.speak),
      callback: function($$v) {
        _vm.speak = $$v
      },
      expression: "speak"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67768188","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/Workflows/Tasks/LocationTag.vue
// module id = 637
// module chunks = 1